import React, { useEffect, useRef, useState, useContext } from "react"
import {
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  TextField,
  Typography,
  Box,
  Button,
} from "@mui/material"
import PropTypes from "prop-types"
import CloseIcon from "@mui/icons-material/Close"
import CheckCircleOutlineSharpIcon from "@mui/icons-material/CheckCircleOutlineSharp"
import ErrorOutlineSharpIcon from "@mui/icons-material/ErrorOutlineSharp"
import AuthContext from "context/auth/authContext"
import { useParams } from "react-router-dom"
import ProjectContext from "context/projects/projectContext"
import i18n from "i18n"
import cloudDownload from "assets/customIcons/somethingIsBad.svg"
import { ROLE_OPTIONS } from "./constants/roles"

const InviteUserModal = ({ open, setOpen }) => {
  const refNombre = useRef(null)
  const refEmail = useRef(null)
  const [campos, guardarCampos] = useState({
    nombre: "",
    email: "",
  })
  const { projectId } = useParams()
  const [selectedRol, setSelectedRol] = useState("")
  const { user, sendInvitation } = useContext(AuthContext)
  const { getProject } = useContext(ProjectContext)

  useEffect(() => {
    getProject(projectId)
  }, [])

  const obtenerCampos = e => {
    guardarCampos({
      ...campos,
      [e.target.name]: e.target.value,
    })
  }

  /*Referencias para iconos confirm and error*/
  const refNombreConfirm = useRef(null)
  const refEmailConfirm = useRef(null)

  const refNombreError = useRef(null)
  const refEmailError = useRef(null)

  const [validaNombre, setValidaNombre] = useState(false)
  const [validaMail, setValidaMail] = useState(false)

  const handleEnter = event => {
    if (event.key.toLowerCase() === "enter") {
      const form = event.target.form
      const index = [...form].indexOf(event.target)
      form.elements[index + 1].focus()
      event.preventDefault()
    }
  }
  const onFocus = e => {
    if (e.target.name == "nombre") {
      refNombre.current["id"] = "focus"
      refNombreConfirm.current.id = "confirmNotVisible"
      refNombreError.current.id = "errorNotVisible"
    } else if (e.target.name == "email") {
      refEmail.current["id"] = "focus"
      refEmailConfirm.current.id = "confirmNotVisible"
      refEmailError.current.id = "errorNotVisible"
    }
  }
  function nameIsValid(name) {
    var matches = name.match(/\d+/g)
    if (matches != null) {
      return false
    } else {
      return true
    }
  }
  const [loading, setLoading] = useState(false)
  function emailIsValid(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }
  const onBlur = e => {
    if (e.target.name == "nombre") {
      if (nameIsValid(campos.nombre) && campos.nombre.length > 0) {
        setValidaNombre(true)
        refNombre.current.id = " "
        refNombreConfirm.current.id = "confirmVisible"
        refNombreError.current.id = "errorNotVisible"
      } else {
        refNombre.current.id = "errorValidation"
        setValidaNombre(false)
        refNombreConfirm.current.id = "confirmNotVisible"
        refNombreError.current.id = "errorVisible"
      }
    } else if (e.target.name == "email") {
      if (emailIsValid(campos.email)) {
        setValidaMail(true)
        refEmail.current.id = " "
        refEmailConfirm.current.id = "confirmVisible"
        refEmailError.current.id = "errorNotVisible"
      } else {
        refEmail.current.id = "errorValidation"
        setValidaMail(false)
        refEmailError.current.id = "errorVisible"
        refEmailConfirm.current.id = "confirmNotVisible"
      }
    }
  }

  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")

  const handleInvite = async e => {
    e.preventDefault()
    const isNameValid = nameIsValid(campos.nombre) && campos.nombre.length > 0
    const isMailValid = emailIsValid(campos.email)

    if (!isNameValid) {
      refNombre.current.id = "errorValidation"
      refNombreConfirm.current.id = "confirmNotVisible"
      refNombreError.current.id = "errorVisible"
    } else {
      refNombre.current.id = " "
      refNombreConfirm.current.id = "confirmVisible"
      refNombreError.current.id = "errorNotVisible"
    }

    if (!isMailValid) {
      refEmail.current.id = "errorValidation"
      refEmailError.current.id = "errorVisible"
      refEmailConfirm.current.id = "confirmNotVisible"
    } else {
      refEmail.current.id = " "
      refEmailConfirm.current.id = "confirmVisible"
      refEmailError.current.id = "errorNotVisible"
    }

    setValidaNombre(isNameValid)
    setValidaMail(isMailValid)

    if (isMailValid && isNameValid) {
      const roleConfig = ROLE_OPTIONS.find(role => role.value === selectedRol)
      const customRole = roleConfig
        ? {
            color: roleConfig.color,
            value: roleConfig.value,
            bgColor: roleConfig.bgColor,
          }
        : {}
      setLoading(true)
      const result = await sendInvitation({
        email: campos.email,
        name: campos.nombre,
        customRole: customRole,
        organizationId: user["custom:organizationId"],
      })
      console.log(result)
      setLoading(false)
      if (!result?.member) {
        setErrorMessage(result)
        setError(true)
      } else {
        setOpen(false)
      }
    }
  }
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      maxWidth="xs"
      fullWidth
      PaperProps={{ "data-testid": "team-invite-modal" }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography sx={{ fontWeight: "bold", fontSize: "1.1rem" }}>
          {i18n.t("Invitar Usuario")}
        </Typography>
        <IconButton
          onClick={() => setOpen(false)}
          sx={{ ml: 1 }}
          data-testid="team-invite-modal-close"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {error ? (
          <Box sx={{ textAlign: "center", py: 2 }}>
            <img
              src={cloudDownload}
              style={{ width: "100px", height: "70px" }}
            />
            <Typography sx={{ fontWeight: "bold", mt: 2 }}>
              {i18n.t("Parece que ha ocurrido un error")}
            </Typography>
            {errorMessage == "user already exists in the organization" ? (
              <Typography sx={{ fontSize: "12px", mt: 1 }}>
                {i18n.t(
                  "El usuario al que intentas invitar ya pertenece a esta organización",
                )}
              </Typography>
            ) : errorMessage ==
              "user already belongs to another organization" ? (
              <Typography sx={{ fontSize: "12px", mt: 1 }}>
                {i18n.t(
                  "El usuario al que intentas invitar ya tiene una cuenta creada",
                )}
              </Typography>
            ) : errorMessage == "user already invited" ? (
              <Typography sx={{ fontSize: "12px", mt: 1 }}>
                {i18n.t(
                  "El usuario al que intentas invitar ya ha sido invitado",
                )}
              </Typography>
            ) : errorMessage == "user already has an organization" ? (
              <Typography sx={{ fontSize: "12px", mt: 1 }}>
                {i18n.t(
                  "El usuario al que intentas invitar ya pertenece a otro equipo",
                )}
              </Typography>
            ) : (
              <Typography sx={{ fontSize: "12px", mt: 1 }}>
                {i18n.t("Nuestro equipo esta trabajando en ello,")}
                <br />
                {i18n.t("Pruebe de nuevo mas tarde")}
              </Typography>
            )}
          </Box>
        ) : (
          <Box component="form" id="Form" sx={{ mt: 1 }}>
            <TextField
              name="nombre"
              label={i18n.t("Nombre y Apellido")}
              placeholder={i18n.t("Nombre Apellido")}
              value={campos.nombre}
              onChange={obtenerCampos}
              onFocus={onFocus}
              onBlur={onBlur}
              onKeyDown={handleEnter}
              inputRef={refNombre}
              fullWidth
              size="small"
              sx={{ mb: 2 }}
              inputProps={{ "data-testid": "team-invite-name-input" }}
              InputProps={{
                endAdornment: (
                  <>
                    <CheckCircleOutlineSharpIcon
                      style={{ width: "16px", color: "#3BA452" }}
                      ref={refNombreConfirm}
                      id="confirmNotVisible"
                    />
                    <ErrorOutlineSharpIcon
                      style={{ width: "16px", color: "#BF2929" }}
                      ref={refNombreError}
                      id="errorNotVisible"
                    />
                  </>
                ),
              }}
            />
            <TextField
              name="email"
              label={i18n.t("Email")}
              placeholder="Email"
              value={campos.email}
              onChange={obtenerCampos}
              onFocus={onFocus}
              onBlur={onBlur}
              onKeyDown={handleEnter}
              inputRef={refEmail}
              fullWidth
              size="small"
              sx={{ mb: 2 }}
              inputProps={{ "data-testid": "team-invite-email-input" }}
              InputProps={{
                endAdornment: (
                  <>
                    <CheckCircleOutlineSharpIcon
                      style={{ width: "16px", color: "#3BA452" }}
                      ref={refEmailConfirm}
                      id="confirmNotVisible"
                    />
                    <ErrorOutlineSharpIcon
                      style={{ width: "16px", color: "#BF2929" }}
                      ref={refEmailError}
                      id="errorNotVisible"
                    />
                  </>
                ),
              }}
            />
            <TextField
              select
              label={i18n.t("Rol de usuario")}
              value={selectedRol}
              onChange={e => setSelectedRol(e.target.value)}
              fullWidth
              size="small"
              sx={{ mb: 2 }}
              data-testid="team-invite-role-select"
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    "data-testid": "team-invite-role-select-menu",
                  },
                },
              }}
            >
              {ROLE_OPTIONS.map(role => (
                <MenuItem
                  key={role.value}
                  value={role.value}
                  data-testid={`team-invite-role-option-${role.value}`}
                >
                  {i18n.t(role.label)}
                </MenuItem>
              ))}
            </TextField>
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ p: "16px 24px" }}>
        {error ? (
          <Button
            variant="contained"
            color="branded"
            sx={{
              minWidth: "100px",
              height: "36px",
            }}
            onClick={() => setOpen(false)}
            data-testid="team-invite-error-accept-button"
          >
            {i18n.t("Aceptar")}
          </Button>
        ) : (
          <Button
            variant="contained"
            color="branded"
            sx={{
              minWidth: "100px",
              height: "36px",
            }}
            onClick={handleInvite}
            disabled={loading}
            data-amplify-analytics-on="click"
            data-amplify-analytics-name="UserInvited"
            data-amplify-analytics-attrs={campos}
            data-testid="team-invite-submit-button"
          >
            {loading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              i18n.t("Invitar")
            )}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}

InviteUserModal.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
}
export default InviteUserModal
